export default {
  showPdfCashRegisterSquare: false,
  fileNamePdfCashRegisterSquare: "",
  fileNamePdfCashRegisterSquareEmail: "",
  itemHistoryTableSelected: {},
  loadingPdf: false,
  loading:{
      module :false
  },
  itemsHistoryTable: [],
  cash_registers: [],
  fieldsHistoryTable: [
    {
      key: "dateFrom",
      label: "Fecha/Hora Desde"
    },
    {
      key: "dateTo",
      label: "Fecha/Hora Hasta"
    },
    {
      key: "actions",
      label: "Acciones"
    }
  ],
  paramsGeneratePdf: {
    dateFrom: "",
    timeFrom: "",
    dateTo: "",
    timeTo: "",
    cash_register_id: null,
    branchoffice_id: "",
    branch_office_warehouse_id: "",
    payment_method_id:[],
    note: ""
  },
  paramsHistoryTable: {
    dateFrom: ""
  },
  paymentMethods:[],
  listBranchOfficesWarehouses:[],
};



// WEBPACK FOOTER //
// ./src/modules/cash-register-square/state.js